import { __extends } from "tslib";
import { deserializeAws_restJson1_1GetExportJobCommand, serializeAws_restJson1_1GetExportJobCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetExportJobCommand = /** @class */ (function (_super) {
    __extends(GetExportJobCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetExportJobCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetExportJobCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetExportJobCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1GetExportJobCommand(input, context);
    };
    GetExportJobCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1GetExportJobCommand(output, context);
    };
    return GetExportJobCommand;
}($Command));
export { GetExportJobCommand };
//# sourceMappingURL=GetExportJobCommand.js.map